import '../CsvJsonInfoPages.scss';


function OptionDescriptionsNVDE() {

    const data = [
        { field: 1, description: 'Option Code (Int)' },
        { field: 2, description: 'Manufacturer Code (Int)' },
        { field: 3, description: 'Category Code (Int)' },
        { field: 4, description: 'Description (Char)' },
        { field: 5, description: 'Long Description (Char)' },
        { field: 6, description: 'Non-specific Cost Option (Bit)' },
    ];



    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Option Descriptions</h1>
            <p>This file contains the descriptions for all Optional and Standard Items<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryOption.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryOption.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryOption.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryOption.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
             Note: A manufacturer code of zero means the option is Common to multiple manufacturers. 
            </p>
        </div>
    );
}

export default OptionDescriptionsNVDE;
